/* eslint-disable */
/* istanbul ignore file */
// @generated
// This file was auto-generated. Do not edit!

import gql from 'graphql-tag';

export default gql`
# ------------------------------------------------------
# THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
# ------------------------------------------------------

type Address {
  organization: String
  street: String
  houseNumber: String
  postCode: String
  city: String

  """Holds an ISO 3166 country code."""
  country: String

  """Holds the ISO 3166 official country name."""
  countryName: String
}

type AssignedPermission {
  id: ID!
  permissionId: ID!
  granted: Boolean!
}

type MarketingDeadline {
  deadlineForEarliestForecast: String!
  daysBeforeDelivery: Int!
  minutesBeforeIntradayDelivery: Int
}

type Interval {
  start: DateTime!
  end: DateTime!
}

"""
A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format.
"""
scalar DateTime

type Measure {
  value: Float!
  unit: String!
}

type NullableMeasure {
  value: Float
  unit: String!
}

"""Provides information about the current page."""
type PageInfo {
  """Indicates whether more elements exist before the current page."""
  hasPreviousPage: Boolean!

  """Indicates whether more elements exist after the current page."""
  hasNextPage: Boolean!

  """The cursor to the first element of the current page."""
  startCursor: String

  """The cursor to the last element of the current page."""
  endCursor: String
}

type Product {
  id: ID!
  name: String!
  marketingDeadline: MarketingDeadline
}

type AssignedMarketLocation {
  id: ID!
  name: String!
  externalName: String
}

type Account {
  id: ID!
  email: String!
  name: String!
  permissions: [AssignedPermission!]!
  marketLocations: [AssignedMarketLocation!]
}

type DeleteAccountResponse {
  deleted: Boolean!
}

type DefaultForecastSlice {
  interval: Interval!
  value: NullableMeasure!
}

type DefaultForecast {
  id: ID!
  month: Month!
  auxiliaryConsumption: NullableMeasure!
  minimum: NullableMeasure!
  maximum: NullableMeasure!
  forecasts: [DefaultForecastSlice!]!
}

enum Month {
  APRIL
  AUGUST
  DECEMBER
  FEBRUARY
  JANUARY
  JULY
  JUNE
  MARCH
  MAY
  NOVEMBER
  OCTOBER
  SEPTEMBER
}

type Datapoint {
  type: DatapointType!
  value: Float!
}

enum DatapointType {
  AFRR_BAND_NEGATIVE
  AFRR_BAND_POSITIVE
  AFRR_LOWER_LIMIT
  AFRR_UPPER_LIMIT
  AVAILABILITY
  DAY_AHEAD_COMMITTED_PRODUCTION
  DOWNTIME
  FCR_BAND
  FLEXPLUS_LOWER_LIMIT
  FLEXPLUS_UPPER_LIMIT
  MFRR_BAND_NEGATIVE
  MFRR_BAND_POSITIVE
  MFRR_LOWER_LIMIT
  MFRR_UPPER_LIMIT
  POWER_FEED
  POWER_PRODUCTION
}

type Entity {
  number: Int!
  datapoints: [Datapoint!]!
}

type TimeSlice {
  timestamp: DateTime!
  entities: [Entity!]!
}

type DatapointCollection {
  type: DatapointCollectionType!
  resolution: Resolution!
  entityType: EntityType!
  timeSlices: [TimeSlice!]!
}

enum DatapointCollectionType {
  DSO_MEASUREMENT
  FORECAST
  VPP_MEASUREMENT
}

enum Resolution {
  FIFTEEN_MINUTES
  FOUR_HOURS
  ONE_HOUR
}

enum EntityType {
  DEVICE
  MARKET_LOCATION
}

type RevokeLegacyDowntimeResponse {
  revokeLegacyDowntime: DatapointCollection!
}

type SetLegacyDowntimeResponse {
  setLegacyDowntime: DatapointCollection!
}

type Deadline {
  type: InputFieldType!
  deadline: MarketingDeadline
}

enum InputFieldType {
  PRODUCTION
  POWER_FEED
  DAY_AHEAD_COMMITTED_PRODUCTION
  AFRR_POSITIVE
  AFRR_NEGATIVE
  AFRR_LOWER_LIMIT
  AFRR_UPPER_LIMIT
  MFRR_POSITIVE
  MFRR_NEGATIVE
  MFRR_LOWER_LIMIT
  MFRR_UPPER_LIMIT
  FCR
  FLEX_PLUS_LOWER_LIMIT
  FLEX_PLUS_UPPER_LIMIT
}

type Device {
  id: ID!
  internalId: ID!
  name: String!
  tradingGroupId: ID
  products: [Product!]!
  deadlines: [Deadline!]!
  externalName: String
}

type Machine {
  id: ID!
  name: String!
  machineTechnology: MachineTechnology!
  devices: [Device!]!
  installedPower: NullableMeasure!
  address: Address!
}

enum MachineTechnology {
  OTHER
  CONVENTIONAL
  BIOGAS
  SOLAR
  WIND
  WATER
  BATTERY
  BIOMASS
  COMPOSITE
}

type BillingType {
  year: Int!
  month: Month!
  isOpenBook: Boolean!
}

type ForecastProperty {
  resolution: Resolution!
  editableMarkets: [EditableMarket!]!
  target: ForecastTarget!
  validFrom: String!
  validTo: String
}

enum EditableMarket {
  DAY_AHEAD
  INTRADAY
}

enum ForecastTarget {
  ESDB
  VPP
}

type MarketLocationPermissions {
  seeForecast: Boolean!
  editForecast: Boolean!
  seeRevenue: Boolean!
}

type ProductService {
  type: ProductServiceType!
  begin: String!
  end: String
}

enum ProductServiceType {
  COMMISSION
  DAY_AHEAD_OPTIMIZATION
  INTRADAY_MARKETING
  INTRADAY_OPTIMIZATION
}

type MarketLocation {
  id: ID!
  number: String!
  marketLocationId: String!
  measureLocationId: String!
  name: String!
  externalName: String!
  products: [Product!]!
  machines: [Machine!]!
  technologies: [MachineTechnology!]!
  machinesTotalOutput: NullableMeasure!
  contractPartner: String!
  distributionNetworkOperator: String
  transmissionSystemOperator: String
  marketingStart: DateTime
  marketingEnd: DateTime
  permissions: MarketLocationPermissions!
  billingTypes: [BillingType!]!
  productServices: [ProductService!]!
  forecastProperties: [ForecastProperty!]
  type: MarketLocationType
  linkedMarketLocation: MarketLocation
}

enum MarketLocationType {
  CONSUMER
  PRODUCER
  PROSUMER
}

type SparseMarketLocation {
  id: ID!
  name: String!
  externalName: String!
  technologies: [MachineTechnology!]!
  contractPartner: String!
  marketingStart: DateTime
  marketingEnd: DateTime
  permissions: MarketLocationPermissions!
  type: MarketLocationType
  linkedMarketLocation: SparseMarketLocation
}

"""Edge type for {@link MarketLocation} elements."""
type MarketLocationEdge {
  """The cursor pointing to the element within the {@link node} field."""
  cursor: String!

  """The current element."""
  node: MarketLocation!
}

"""
A pageable list for {@link MarketLocation} elements that also contains meta information.
"""
type MarketLocationConnection {
  """The total number of elements across all pages."""
  totalCount: Int!

  """Contains meta information about the current page."""
  pageInfo: PageInfo!

  """Contains the edges of the current page."""
  edges: [MarketLocationEdge!]!
}

"""Edge type for {@link SparseMarketLocation} elements."""
type SparseMarketLocationEdge {
  """The cursor pointing to the element within the {@link node} field."""
  cursor: String!

  """The current element."""
  node: SparseMarketLocation!
}

type MonthlyMarketValue {
  year: Int!
  month: Month!
  min: Float!
  max: Float!
  mean: Float!
  isProvisional: Boolean!
}

type SpotPriceForecastSlice {
  price: Float!
  date: DateTime!
}

type SpotPriceForecast {
  resolution: Resolution!
  dayAheadForecasts: [SpotPriceForecastSlice!]!
  intradayForecasts: [SpotPriceForecastSlice!]!
  monthlyMarketValues: [MonthlyMarketValue!]!
  latestHistoricalSpotPrice: DateTime
  lastUpdated: DateTime
}

type FieldValue {
  type: InputFieldType!
  watt: Int
}

type ForecastSlice {
  id: ID!
  date: DateTime!
  hasDowntime: Boolean!
  fields: [FieldValue!]!
}

type Forecast {
  id: ID!
  deviceId: ID!
  interval: Interval!
  resolution: Resolution!
  slices: [ForecastSlice!]!
}

type MonthOverview {
  month: Month!
  totalForecasted: NullableMeasure!
  meanForecasted: NullableMeasure!
  totalMeasurement: NullableMeasure!
  meanMeasurement: NullableMeasure!
  totalConsumptionMeasurement: NullableMeasure!
  meanConsumptionMeasurement: NullableMeasure!
  totalMeasuredFeedsAtLeast85PercentOfCapacity: Int!
  specificAdditionalRevenue: NullableMeasure!
}

type AnnualOverview {
  marketLocationId: ID!
  totalForecastedSum: NullableMeasure!
  totalForecastedMean: NullableMeasure!
  totalMeasurementSum: NullableMeasure!
  totalMeasurementMean: NullableMeasure!
  totalConsumptionMeasurementSum: NullableMeasure!
  totalConsumptionMeasurementMean: NullableMeasure!
  latestFeedDate: DateTime
  totalMeasuredFeedsAtLeast85PercentOfCapacity: Int!
  monthlyOverview: [MonthOverview!]!
}

type DeviceTimeSeries {
  id: ID!
  deviceNumber: ID!
  datapoints: [DeviceDatapoint!]!
}

type DeviceDatapoint {
  date: DateTime!
  energyCapabilityPos: Float
  energyCapabilityNeg: Float
  actualPower: Float
}

type FeedInValue {
  date: DateTime!
  forecastedValue: Float
  measuredValue: Float
  msconsCode: String
}

type FeedIn {
  id: ID!
  marketLocationId: ID!
  interval: Interval!
  values: [FeedInValue!]!
}

type MarketLocationTimeSeries {
  id: ID!
  marketLocationNumber: ID!
  marketLocationTimeSeriesType: MarketLocationTimeSeriesType!
  datapoints: [MarketLocationDatapoint!]!
}

enum MarketLocationTimeSeriesType {
  CALCULATED_PV_PRODUCTION
}

type MarketLocationDatapoint {
  timestamp: DateTime!
  value: Float
}

type Limit {
  limit: Measure!
  limitSpecification: LimitSpecification!
}

enum LimitSpecification {
  PAIRED_MAXIMUM
  CONTRACTUAL
  TECHNICAL
  TEMPLATE
  INSTALLED_CAPACITY
  FCR
}

type ProductLimits {
  product: ProductType!
  doubleStrokeLowerLimit: Measure!
  doubleStrokeUpperLimit: Measure!
  contractLowerLimit: NullableMeasure!
  contractUpperLimit: NullableMeasure!
  flexBandLimit: NullableMeasure!
}

enum ProductType {
  AFRR_NEG
  AFRR_POS
  DM
  FCR_NEG
  FCR_POS
  FLEXPLUS
  MFRR_NEG
  MFRR_POS
}

type ProductLimitsPeriod {
  productLimits: [ProductLimits!]!
  validFrom: DateTime!
  validTo: DateTime
}

type ForecastPageFieldLimit {
  type: InputFieldType!
  positiveBand: NullableMeasure
  negativeBand: NullableMeasure
  lowerLimit: Limit!
  upperLimit: Limit!
  isDisabled: Boolean!
}

type ForecastPageLimitsResponse {
  installedPower: NullableMeasure!
  fields: [ForecastPageFieldLimit!]!
}

type DeviceOptimizationStatus {
  deviceId: String!
  isActive: Boolean!
  nextRun: DateTime
  interval: String
}

type OptimizationFileList {
  files: [String!]!
  modelNamesWithoutFiles: [String!]!
}

type OptimizationStatus {
  id: ID!
  isAuthorized: Boolean!
  authorizedFeatures: [OptimizationFeatures!]!
  optimizedContractIds: [Int!]!
}

enum OptimizationFeatures {
  PORTAL_REDIRECT
  SCHEDULE_DOWNLOAD
}

type RevenueItem {
  key: ID!
  amount: Float
  price: Float
  sum: Float
}

type RevenueReport {
  marketLocationId: ID!
  items: [RevenueItem!]!
}

type SalesPartner {
  id: ID!
  name: String!
  permissions: [AssignedPermission!]!
  assignedMarketLocations: [AssignedMarketLocation!]!
  contractPartnerNumber: Int!
  isConfigured: Boolean!
}

type SalesPartnerGroup {
  id: ID!
  name: String!
  isConfigured: Boolean!
  permissions: [AssignedPermission!]!
}

type Json {
  json: String
}

type OptimizationRun {
  status: String!
}

input AddressInput {
  organization: String
  street: String
  houseNumber: String
  postCode: String
  city: String

  """Holds an ISO 3166 country code."""
  country: String

  """Holds the ISO 3166 official country name."""
  countryName: String
}

input IntervalInput {
  start: DateTime!
  end: DateTime!
}

input MeasureInput {
  value: Float!
  unit: String!
}

input NullableMeasureInput {
  value: Float
  unit: String!
}

type Query {
  permissions: [AssignedPermission!]!
  accounts: [Account!]!
  getDefaultForecast(deviceId: ID!): [DefaultForecast!]!
  feedIn(marketLocations: [FeedInMarketLocation!]!, interval: IntervalInput!): [FeedIn!]!
  annualOverview(marketLocationId: ID!, year: Int!): AnnualOverview!
  deviceTimeSeries(deviceNumbers: [ID!]!, interval: IntervalInput!): [DeviceTimeSeries!]!
  batteryDeviceAcceptedForecasts(deviceNumbers: [ID!]!, interval: IntervalInput!): DatapointCollection!
  marketLocationTimeSeries(marketLocationNumbers: [ID!]!, marketLocationTimeSeriesTypes: [MarketLocationTimeSeriesType!]!, interval: IntervalInput!): [MarketLocationTimeSeries!]!
  forecast(devices: [ID!]!, interval: IntervalInput!, resolution: Resolution!): [Forecast!]!
  batteryForecast(devices: [ID!]!, interval: IntervalInput!): [Forecast!]!
  spotPrices(resolution: Resolution!, from: DateTime!, to: DateTime!): SpotPriceForecast!
  marketLocation(id: ID!): MarketLocation!
  marketLocations(first: Int, last: Int, before: String, after: String): MarketLocationConnection!
  getForecastLimits(device: ForecastPageDeviceInput!, months: [Month!]!): ForecastPageLimitsResponse!
  powerLevels(deviceId: String!): [NullableMeasure!]!
  productLimits(deviceInternalId: String!, from: DateTime!, to: DateTime!): [ProductLimitsPeriod!]!
  optimizationFileList(contractPartnerIds: [String!]!): OptimizationFileList!
  deviceOptimizationStatus(deviceId: String!): DeviceOptimizationStatus!
  optimizationStatus: OptimizationStatus!
  revenueData(scope: RevenueScope!, marketLocationId: ID!, date: DateTime!): RevenueReport!
  salesPartnerGroup: SalesPartnerGroup
  salesPartners: [SalesPartner!]!
  OptimizationGroupData(siteId: String!): Json!
}

input FeedInMarketLocation {
  id: ID!
  type: MarketLocationType
}

input ForecastPageDeviceInput {
  marketLocationId: ID!
  deviceId: ID!
}

enum RevenueScope {
  MONTH
  QUARTER
}

type Mutation {
  createAccount(email: String!, name: String!, permissions: [AssignedPermissionInput!]!, marketLocationIds: [ID!]): Account!
  updateAccount(email: String!, name: String!, permissions: [AssignedPermissionInput!]!, marketLocationIds: [ID!]): Account!
  updateAccountPermission(email: String!, permission: AssignedPermissionInput!): AssignedPermission!
  deleteAccount(email: String!): DeleteAccountResponse!
  changeDefaultForecast(deviceId: ID!, forecast: [DefaultForecastInput!]!): [DefaultForecast!]!
  updateForecast(device: ID!, interval: IntervalInput!, resolution: Resolution!, slices: [ForecastSliceInput!]!): [ForecastSlice!]!
  updateForecastWithTemplate(
    device: ID!
    resolution: Resolution!
    interval: IntervalInput!
    weekdays: [Weekday!]!
    hours: [Int!]!

    """Lists the values that should be set. May be sparse."""
    values: [FieldValueInput!]!
    returnInterval: IntervalInput
  ): [ForecastSlice!]!
  updateDevice(maLoId: ID!, deviceId: ID!, input: DeviceInput!): Device!
  setDowntime(deviceNumber: ID!, from: DateTime!, to: DateTime!): Boolean!
  setLegacyDowntime(marketLocationId: ID!, deviceNumber: ID!, from: DateTime!, to: DateTime!): SetLegacyDowntimeResponse!
  revokeDowntime(deviceNumber: ID!, from: DateTime!, to: DateTime!): Boolean!
  revokeLegacyDowntime(deviceNumber: String!, from: DateTime!, to: DateTime!): RevokeLegacyDowntimeResponse!
  setSalesPartnerConfigured: SalesPartnerGroup!
  setSalesPartnersAsConfigured(contractPartnerNumbers: [Int!]!): [SalesPartner!]!
  setSalesPartnerPermission(permissionId: ID!, granted: Boolean!): AssignedPermission!
  updateSalesPartnerPermission(contractPartnerNumber: Int!, permissionId: ID!, granted: Boolean!): AssignedPermission!
  OptimizationGroupDataUpdate(siteId: String!, updatedParameters: String): Json!
  OptimizationRunner(siteId: String!): OptimizationRun!
}

input AssignedPermissionInput {
  permissionId: ID!
  granted: Boolean!
}

input DefaultForecastInput {
  month: Month!
  auxiliaryConsumption: MeasureInput!
  minimum: MeasureInput!
  maximum: MeasureInput!
  forecasts: [ForecastInput!]!
}

input ForecastInput {
  interval: IntervalInput!
  value: MeasureInput!
}

input ForecastSliceInput {
  date: DateTime!
  fields: [FieldValueInput!]!
  hasDowntime: Boolean
}

input FieldValueInput {
  type: InputFieldType!
  watt: Int!
}

enum Weekday {
  FRIDAY
  MONDAY
  SATURDAY
  SUNDAY
  THURSDAY
  TUESDAY
  WEDNESDAY
}

input DeviceInput {
  externalName: String
}`;
